import React from 'react';
import { useLocation } from 'react-router-dom';
import { AppFooter } from './AppFooter';
import { TopNavigation } from './TopNavigation';
import { AppShell } from './primitives';

interface ModernLayoutProps {
  children: React.ReactNode;
}

export const ModernLayout: React.FC<ModernLayoutProps> = ({ children }) => {
  const location = useLocation();
  const isChatbotConfigRoute = /^\/chatbots\/[^/]+\/config$/.test(location.pathname);
  const isAgentConfigRoute = /^\/agents\/[^/]+\/config$/.test(location.pathname);
  const mainBackgroundClass = isChatbotConfigRoute
    ? 'bg-[linear-gradient(180deg,#FFFFFF_0%,#4CC4D012_100%)]'
    : isAgentConfigRoute
      // Soft full-page ambient wash: faint pink top-right → white → light lavender.
      ? 'bg-[linear-gradient(135deg,rgb(var(--c-fceff1,252_239_241))_0%,#FFFFFF_42%,rgb(var(--c-f3f1fb,243_241_251))_100%)]'
      : 'bg-agentic-white-off';

  return (
    <AppShell className={mainBackgroundClass}>
      <TopNavigation />
      <main className="w-full min-w-0 flex-1 py-0">
        {children}
      </main>
      <AppFooter />
    </AppShell>
  );
};
